import Vuex from 'vuex'
import Vue from 'vue'
import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex)

import internationalization from './modules/internationalization'
import viewpointsSize from './modules/viewpointsSize'
import dateFilterViewer from './modules/dateFilterViewer'
import privacyPolicyConsent from './modules/privacyPolicyConsent'
import demo from './modules/Demo/demo'

export default new Vuex.Store({
    modules: {
        internationalization,
        viewpointsSize,
        dateFilterViewer,
        privacyPolicyConsent,
        demo,
    },
    plugins: [
        createPersistedState({
            overwrite: true,
            paths: ['internationalization', 'viewpointsSize', 'dateFilterViewer', 'privacyPolicyConsent'],
        }),
    ],
    state: {
        packageVersion: process.env.PACKAGE_VERSION || '0',
    },
    getters: {
        appVersion: (state) => {
            return state.packageVersion
        },
    },
})
